import React, { useContext, useEffect, useState } from 'react';
import './ProductDetails.css'
import Image from '../shared/Image';
import phoneImage from '../../public/image/phone.png'
import { priceFormat } from '../../util/showPriceFormat';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getProductInfo } from '../../service/productService';
import MainContext from '../../context/mainContext';
import LoadingBar from '../shared/EclipseLoading';
import config from './../../config.json';
import preview from './../../public/image/preview.png'
import socket from '../../service/socket';
import { charsNormalize } from '../../util/charactorsNormalize';
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import { cleanFloat } from '../../util/cleanFloat';


const ProductDetails = () => {

    const { id: productId } = useParams();
    const { state } = useLocation();
    const [product, setProduct] = useState();
    const navigate = useNavigate();
    const context = useContext(MainContext);

    const [status, setStatus] = useState('disabled');
    const [count, setCount] = useState('');
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!productId) {
            return navigate('/products', { replace: true })
        }
        if (state && state._id) {
            setProduct({ ...state })
        }
        else {
            const cancelRequest = requestCanceller();

            const fetchProductInfo = async () => {
                try {
                    let { status, data } = await getProductInfo(productId, { signal: cancelRequest.signal });
                    if (status === 201)
                        setProduct(data.product)
                } catch (err) {
                }
            }
            fetchProductInfo();
            return () => {
                cancelRequest.cancel();
            }

        }
    }, [productId, state, navigate])

    useEffect(() => {
        try {
            socket.on('product', data => {
                if ((data.action === 'update' || data.action === 'delete') && product._id === data.updatedProduct._id) {
                    navigate('.', { state: undefined, replace: true })
                }
            })
        } catch (err) { }
        return () => socket.off('product');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product])

    const countHandler = (eValue, operator) => {
        let data = {
            _id: product._id,
            name: product.name,
            price: product.price,
            image: product.image,
            inventory: product.inventory,
            unit: product.unit,
            incrementalStep: product.incrementalStep
        }
        switch (operator) {
            case '+':
                if (status === 'enabled') {
                    if (context.appSetting && !context.appSetting.negetiveInventory && product.inventory < (Number(count) || 0) + product.incrementalStep) {
                        return toast.error('موجودی محصول به اتمام رسیده است')
                    }
                    context.addToShoppingCart({ ...data, count: (Number(count) || 0) < 9999 ? cleanFloat((Number(count) || 0) + product.incrementalStep) : Number(count) })
                    setCount(prev => String(cleanFloat(Number(prev || 0) + product.incrementalStep)));
                }
                else if (status === 'disabled') {
                    setStatus('enabled');
                }
                break;
            case '-':
                if (Number(count) - product.incrementalStep > 0) {
                    context.removeFromShoppingCart({ ...data, count: cleanFloat(Number(count) - product.incrementalStep) })
                    setCount(prev => String(cleanFloat(Number(prev) - product.incrementalStep)));
                }
                else if ((Number(count) - product.incrementalStep) <= 0) {
                    context.removeFromShoppingCart({ ...data, count: 0 })
                    setCount('');
                    setStatus('disabled');
                }
                if (count === '' && status === 'enabled') {
                    setStatus('disabled');
                    setCount('');
                }
                break;
            case 'custom':
                if (status === 'enabled' && eValue) {
                    if (context.appSetting && !context.appSetting.negetiveInventory && product.inventory < Number(eValue)) {
                        return toast.error('موجودی محصول به اتمام رسیده است')
                    }
                    context.addToShoppingCart({ ...data, count: Number(eValue) })
                    setCount(String(eValue));
                }
                else if (status === 'enabled' && eValue === '') {
                    context.removeFromShoppingCart({ ...data, count: 0 })
                    setCount(String(eValue))
                }
                status === 'disabled' && setStatus('enabled');
                break;
            default:
                break;
        }
    }
    const onSelectItemHandler = (event) => {
        if (context.appSetting && !context.appSetting.negetiveInventory && product.inventory <= 0) {
            return toast.error('موجودی محصول به اتمام رسیده است')
        }
        let data = {
            _id: product._id,
            name: product.name,
            price: product.price,
            image: product.image,
            inventory: product.inventory,
            unit: product.unit,
            incrementalStep: product.incrementalStep
        }
        setStatus('enabled');
        context.addToShoppingCart({ ...data, count: count ? Number(count) : product.incrementalStep })
        setCount(count ? Number(count) : product.incrementalStep)
    }


    useEffect(() => {
        if (!product) {
            return;
        }
        context.shoppingCart.forEach(element => {
            if (element._id === product._id && !ready) {
                setReady(true)
                setStatus('enabled');
                setCount(String(element.count));
            }
        });
    }, [context.shoppingCart, product, ready])

    // const regix = /^[0-9\b]+$/;
    const regix = /^-?\d*\.?\d*$/;

    return (
        <React.Fragment>
            {
                product ?
                    <React.Fragment>
                        <header className='w-100 search-result mb-2'>
                            <Helmet>
                                <title>آلماتک | {product.name} | فروشگاه آلماتک | روستابازار زنجان | بازارچه روستابازار زنجان</title>
                                <meta name="description" content={`${product.info} - ${"فروش انواع کالاهای اساسی | برنج | حبوبات | مواد غذایی | میوه و سبزیجات | تره بار | آجیل و خشکبار | شوینده و لوازم بهداشتی | لبنیات و ..."}`} />
                            </Helmet>
                            {
                                <h6>
                                    <span className='m-0'></span>
                                    <section className=' me-2 text-center' style={{ width: '40px', cursor: 'pointer' }}
                                        onClick={() => navigate(-1)}
                                    >
                                        <i className='fa fa-arrow-right text-danger fs-5 '></i>
                                    </section>
                                    جزئیات کالا
                                </h6>
                            }
                        </header>
                        <div className='product-details-layer'>
                            <div className='image-section'>
                                <Image
                                    src={product.image ? `${config.api_address}/upload/${product.image}` : preview}
                                    width={window.innerWidth < 576 ? 200 : 250}
                                    height={window.innerWidth < 576 ? 200 : 250}
                                    borderRadius={'10px'}
                                    style={{ objectFit: 'cover', opacity: product.image ? '1' : '.5' }}
                                />
                            </div>
                            <div className='seperator d-none d-md-block'></div>
                            <div className='content col-12 col-md'>
                                <h5>{product.name}</h5>
                                <div>
                                    <span>کد محصول</span>
                                    <span className='mx-2'>:</span>
                                    <span className='text-muted'>{product.code}</span>
                                </div>
                                {
                                    (context.loggedIn && context.loggedIn.status === 'Enable') ?
                                        <div className='w-100 d-flex justify-content-between'>
                                            <div>
                                                <span>قیمت</span>
                                                <span className='mx-2'>:</span>
                                                <span className='text-success'>{priceFormat(product.price)} ریال</span>
                                            </div>
                                            {
                                                product.fakePrice ?
                                                    <div>
                                                        <div className='fake-price-item' style={{ fontSize: '.9rem' }}>
                                                            {priceFormat(String(product.fakePrice))}
                                                        </div>
                                                        <div className='fake-price-line' style={{ bottom: '17px' }}></div>
                                                    </div> : null
                                            }
                                        </div>
                                        :
                                        <div>
                                            <p style={{ textAlign: 'center' }} className='alert alert-warning m-0' role="alert">
                                                {
                                                    context.loggedIn ?
                                                        `برای مشاهده قیمت و ثبت سفارش باید عضویت شما تأیید شود`
                                                        :
                                                        <span>
                                                            برای مشاهده قیمت و ثبت سفارش ابتدا باید وارد {<Link className='alert-link' onClick={() => {
                                                                if (!context.loggedIn) {
                                                                    context.showLogin();
                                                                }
                                                            }}>
                                                                حساب کاربری</Link>} شوید
                                                        </span>
                                                }
                                            </p>
                                        </div>

                                }
                                {
                                    (context.loggedIn && (context.loggedIn.isAdmin || (context.appSetting && !context.appSetting.negetiveInventory))) &&
                                    <div className='d-flex'>
                                        {
                                            Number(product.inventory) <= 0 ?
                                                <span className='badge bg-danger text-light'>ناموجود</span>
                                                :
                                                <>
                                                    <span>موجودی</span>
                                                    <span className='mx-2'>:</span>
                                                    <span className={`ltr ${Number(product.inventory) > 0 ? 'text-secondary' : 'text-danger'}`}>{product.inventory > 100 ? '+100' : product.inventory}</span>
                                                    <span className={`ms-1 ${Number(product.inventory) > 0 ? 'text-secondary' : 'text-danger'}`}>{product.unit}</span>
                                                </>
                                        }
                                    </div>
                                }
                                {
                                    product.info &&
                                    <div>توضیحات : {product.info}</div>
                                }
                                {
                                    (context.appSetting && context.appSetting.purchaseAdvice) &&
                                    <div className="d-flex py-1 flex-row justify-content-start align-items-center alert alert-light">
                                        <Image
                                            src={phoneImage}
                                            width={38}
                                            height={33}
                                            borderRadius={'10px'}
                                        />
                                        <div className='ms-2'>مشاوره خرید</div>
                                        <div className='mx-2'>:</div>
                                        <div className=''>09192770652</div>
                                    </div>
                                }
                                <div>
                                    {
                                        status === 'disabled' ?
                                            <button className='btn btn-lg btn-success'
                                                onClick={onSelectItemHandler}
                                                disabled={(!context.loggedIn || context.loggedIn.status !== 'Enable')}
                                            >
                                                <i className='fa fa-shopping-cart me-2'></i>
                                                افزودن به سبد خرید
                                            </button> :
                                            <div className="count-selection">
                                                <button
                                                    className='btn btn-success btn-lg'
                                                    onClick={e => countHandler(e, '+')}
                                                >
                                                    <i className="fa fa-plus"></i>
                                                </button>
                                                <div className='mx-2'>
                                                    <input
                                                        type='tel'
                                                        className='form-control ltr text-center'
                                                        disabled={context.appSetting && !context.appSetting.customCountInput}
                                                        value={count}
                                                        onChange={(e) => {
                                                            let normalized = '';
                                                            if (e.target.value) {
                                                                normalized = charsNormalize(e.target.value);
                                                            }
                                                            if (normalized === '' || (regix.test(normalized) && Number(normalized) > 0 && Number(normalized) <= 9999)) {
                                                                countHandler(normalized ? normalized : '', 'custom')
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <button
                                                    className='btn btn-danger btn-lg'
                                                    onClick={e => countHandler(e, '-')}
                                                >
                                                    <i className={`${(count <= product.incrementalStep) ? "fa fa-trash" : "fa fa-minus"}`}></i>
                                                </button>
                                                <section className='col-12 text-success'>
                                                    <span >{(product.unit === 'کیلو گرم' && count < 1) ? count * 1000 : count} {(product.unit === 'کیلو گرم' && count < 1) ? 'گرم' :product.unit}</span>
                                                </section>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    :
                    <section style={{
                        height: '60vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <LoadingBar classNames={`ldio-text-danger`} />

                    </section>


            }
        </React.Fragment>
    );
}

export default ProductDetails;